/* eslint-disable no-unused-vars */
// Dummy login details

// eslint-disable-next-line import/prefer-default-export

// Google map API Key
export const googleMapsApiKey = 'AIzaSyD9N67E6zpGuZqT-o_EI8da5qLbWonLOWw';

// login credentials
const loginCredentials = {
    username: 'vendor-two',
    password: '123456',
};
const localLoginCredentials = {
    username: 'my-vendor',
    password: '8xjlB*xx(s3FwAVyh8',
};
export const loginToken = Buffer.from(
    `${loginCredentials.username}:${loginCredentials.password}`,
    'utf8'
).toString('base64');

export const localLoginToken = Buffer.from(
    `${localLoginCredentials.username}:${localLoginCredentials.password}`,
    'utf8'
).toString('base64');

export const authorizeToken = Buffer.from(
    `${loginCredentials.username}:${loginCredentials.password}`
).toString('base64');

const deBase64 = Buffer.from(authorizeToken, 'base64').toString();
